import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state';

/** Anchor the selection at the clicked task item before the checkbox toggles: otherwise the
 *  toggle records the previous (possibly far-away) selection and undo scrolls back to it. */
const getTaskItemCheckboxSelectionPlugin = () =>
  new Plugin({
    key: new PluginKey('task-item-checkbox-selection'),
    props: {
      handleDOMEvents: {
        // Tiptap v3 prevents the checkbox's mousedown before ProseMirror handles it.
        // Click is not a built-in ProseMirror event, so it still reaches this plugin.
        click: (view, event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return false;
          const item = target.closest('li[data-checked]');
          if (!item || !view.dom.contains(item)) return false;
          const pos = view.posAtDOM(item, 0);
          if (pos < 0) return false;

          view.dispatch(view.state.tr.setSelection(TextSelection.near(view.state.doc.resolve(pos))));
          return false;
        },
      },
    },
  });

export default getTaskItemCheckboxSelectionPlugin;
